import log from 'loglevel';
import AngularHelper from '../angular/AngularHelper.js';

var Araqne = window.Araqne;

function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

var FN_ARGS = /^function\s*[^\(]*\(\s*([^\)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(.+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
function annotate(fn) {
	var $inject,
			fnText,
			argDecl,
			last;

	if (typeof fn == 'function') {
		if (!($inject = fn.$inject)) {
			$inject = [];
			fnText = fn.toString().replace(STRIP_COMMENTS, '');
			argDecl = fnText.match(FN_ARGS);
			argDecl[1].split(FN_ARG_SPLIT).forEach(function(arg){
				arg.replace(FN_ARG, function(all, underscore, name){
					$inject.push(name);
				});
			});
			fn.$inject = $inject;
		}
	} else if (Array.isArray(fn)) {
		last = fn.length - 1;
		assertArgFn(fn[last], 'fn')
		$inject = fn.slice(0, last);
	} else {
		assertArgFn(fn, 'fn', true);
	}
	return $inject;
}

var map = {
	// 'serviceChart2': 'ChartService',
	// 'serviceUtility': 'UtilityService',
	// 'serviceTranslate': 'TranslateService'
}

function convertNewInjection(injects) {
	return injects.map(function(ij) {
		if(!!map[ij]) {
			return map[ij];
		}
		else return ij;
	});
}

class WidgetLoader {
	constructor(msgbus) {
		this.msgbus = msgbus;
		this.services = {};

		if(typeof window.logpresso === 'undefined') {
			window.logpresso = {};
		}

		window.logpresso.register = AngularHelper;
		// window.logpresso.register = angular.merge(window.logpresso.register,AngularHelper.config());
		window.logpresso.register.dashboardWidget = function(type, clazz) {
			var injects = annotate(clazz);
			injects = convertNewInjection(injects);
			clazz.$inject = injects;
			AngularHelper.service(capitalizeFirstLetter(type) + 'WidgetService', clazz);
		}
	}

	getApps(callback) {
		this.msgbus.send('org.araqne.webconsole.plugins.AppPlugin.getApps', { 'locale': 'ko' })
		.onSuccess((resp) => {
			var installed = resp.apps.filter((app) => {
				let assets = app.features['dashboard-assets'];
				return Array.isArray(assets) && assets.length > 0;
			});

			callback(installed);
		})
		.onFailure((resp) => {
			console.warn(resp);
		});
	}

	registerWidget(type) {
		return (module) => {
			// console.warn(module);
			 // new Promise((resolve, reject) => {
			if(!module) {
				log.debug(type, 'is undefined');
				// resolve(type);
			}
			// console.log(module)
			if(!module.service) {
				AngularHelper.inject.factory(capitalizeFirstLetter(type) + 'WidgetService').then(service => {
					log.debug(service);
					this.services[type] = service;
					// resolve(type);
				});
			}
			else {
				if(Array.isArray(module.service.$inject)) {
					log.debug(type, 'is registered(angular)');

					AngularHelper.service(type + 'WidgetService', module.service);
					// resolve(type);
				}
				else {
					log.debug(type, 'is registered');

					this.services[type] = module.service;
					// resolve(type);
				}
			}
		// });
		}
	}

	getDefaultAssets() {
		return {
			"id": "default-assets",
			"display_names": {
				"ko": "Dashboard Default Assets"
			},
			"version": "1.0",
			"description": "Dashboard Default Assets",
			"manifest_version": "1.0",
			"features": {
				"dashboard-assets": [
					{
						"id": "chart",
						"display_name": '$S_wtp_Chart',
						"scripts": ["app.js"],
						"property": "property.html",
						"widget": "widget.html"
					},
					{
						"id": "grid",
						"display_name": '$S_wtp_Grid',
						"scripts": ["app.js"],
						"property": "property.html",
						"widget": "widget.html"
					},
					{
						"id": "wordcloud",
						"display_name": '$S_wtp_WordCloud',
						"scripts": ["app.js"],
						"property": "property.html",
						"widget": "widget.html"
					},
					{
						"id": "alertbox",
						"display_name": '$S_wtp_AlertBox',
						"libraries": ["chroma.js"],
						"scripts": ["app.js"],
						"property": "property.html",
						"widget": "widget.html"
					},
					// {
					// 	"id": "filter",
					// 	"display_name": '필터',
					// 	"libraries": [],
					// 	"scripts": ["app.js"],
					// 	"property": "property.html",
					// 	"widget": "widget.html"
					// },
					{
						"id": "multiselect",
						"display_name": '셀렉션',
						"libraries": [],
						"scripts": ["app.js"],
						"property": "property.html",
						"widget": "widget.html"
					},
					{
						"id": "datetimepicker",
						"display_name": '날짜 선택',
						"libraries": [],
						"scripts": ["app.js"],
						"property": "property.html",
						"widget": "widget.html"
					},
					{
						"id": "selectbox",
						"display_name": '선택 상자',
						"libraries": [],
						"scripts": ["app.js"],
						"property": "property.html",
						"widget": "widget.html"
					},
					{
						"id": "inputbox",
						"display_name": '입력 상자',
						"libraries": [],
						"scripts": ["app.js"],
						"property": "property.html",
						"widget": "widget.html"
					}
					// ,{
					// 	"id": "sandbox",
					// 	"display_name": 'Sandbox',
					// 	"libraries": [],
					// 	"scripts": ["app.js"],
					// 	"property": "property.html",
					// 	"widget": "widget.html"
					// }
				]
			}
		}
	}

	getResources(installed, callback) {

		installed.push(this.getDefaultAssets());

		installed.forEach(manifest => {
			// console.log(manifest)
			this.getDashboardAsset(manifest);
		});

		setTimeout(() => {
			callback(this.services);
		}, 1000);
	}

	getStyleSheets(prefix, manifest) {
		var arr = [];
		if( Array.isArray(manifest.widget) ) {
			arr = manifest.widget.filter(function(path) {
				if(!!path.match(/^app\.css$/)) {
					return prefix + manifest.widget;
				}
			});
		}
		else if( typeof manifest.widget == 'string' ) {
			if(!!manifest.widget.match(/^app\.css$/)) {
				arr = [ prefix + manifest.widget ];
			}

		}

		var HTMLstr = arr.map(function(path) {
			return '<link rel="stylesheet" href="' + path + '" type="text/css" />';
		}).join('\n');

		$('head').append(HTMLstr);
	}

	getDashboardAsset(manifest) {
		return new Promise((resolve, reject) => {
			manifest.features['dashboard-assets'].forEach(ext => {
				var prefix = '/apps/' + manifest.id + '/' + ext.id + '/';

				this.getStyleSheets(prefix, ext);

				this.getLibraries(prefix, ext)
				.done(() => {
					// console.log('-----------loaded libraries --------');

					System.import(prefix + ext.scripts[0]).then(this.registerWidget(ext.id));
				});
			});
		});
	}

	getLibraries(prefix, manifest) {
		var arr = [];
		if( angular.isArray(manifest.libraries) ) {
			arr = manifest.libraries.map(function(path) {
				return $.getScript(prefix + path);
			});
		}
		else if( angular.isString(manifest.libraries) ) {
			arr = [ $.getScript(prefix + manifest.libraries) ];
		}

		arr.push($.Deferred(function(deferred) {
			$(deferred.resolve);
		}));

		return $.when.apply(this, arr);
	}


	load(callback = () => {}) {
		this.getApps(installed => {
			this.getResources(installed, callback);
		});
	}
}

export default WidgetLoader;



// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/WidgetLoader.js